import React from 'react';
import { connect } from 'react-redux';
import StandardLayout from '../../../../../../components/Layout/StandardLayout';
import WhatasppReminderTemplates from '../../../../../../components/Layout/AutoReminders/AutoReminderSettings/WhatasppReminderTemplates';

const ROLEX_INQUIRY_TYPE = 'rolexInquiry';

const InquiryReminderWhatsappTemplate = props => {
  const { reminderId } = props.match.params;

  return (
    <StandardLayout
      title={`${
        window.location.href.includes('add-auto-whatsapp') ? 'Add' : 'Edit'
      } Whatsapp Template for Auto Reminder`}
      description="Sales associates will be able to choose to send this message instead of typing their own"
      breadCrumbs={[
        { title: 'Configuration' },
        { title: 'Rolex Inquiry', to: '/Configuration/rolex' },
        {
          title: 'Auto Reminder',
          to: `/Configuration/rolex/edit-auto-reminder/${reminderId}`,
        },
      ]}
      classProps="standard-width-with-sidebar"
    >
      <WhatasppReminderTemplates
        popConfirmDesc="This will remove the template from this Reminder"
        cancelRoute={`/Configuration/rolex/edit-auto-reminder/${reminderId}`}
        type={ROLEX_INQUIRY_TYPE}
        match={props.match}
      />
    </StandardLayout>
  );
};

const mapStateToProps = state => ({
  ...state.auth,
  ...state.autoRemMsgs,
});

export default connect(mapStateToProps, {})(InquiryReminderWhatsappTemplate);
